import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faSpinnerThird,
} from "@fortawesome/sharp-regular-svg-icons";

import styles from "./continue-button.module.scss";

type ContinueButtonProps = Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  "children"
> & {
  children?: string;
  isLoading?: boolean;
};

export const ContinueButton = ({
  type,
  children = "Continue",
  isLoading = false,
  className,
  ...props
}: ContinueButtonProps) => (
  <button
    type={type === "submit" ? "submit" : "button"}
    {...props}
    className={classNames(className, styles.continueButton)}
  >
    {children}
    <div className={styles.icon}>
      <FontAwesomeIcon
        icon={isLoading ? faSpinnerThird : faArrowRight}
        className={classNames({
          [styles.loadingSpinner]: isLoading,
        })}
      />
    </div>
  </button>
);
